(() => {
  const $storeInfo = $('#storeInfo');
  const $buttonAdd = $('#button-add');
  const $zoneWidget = $("#zonewidget");
  const $pickupInput = $('#storePickupRadio');
  const $pickupError = $('.store-pickup-error');
  const $pickupAddress = $('.store_pick_addr');
  const $shippingNotSelectedError = $('.shipping-not-selected-error');
  const $homeDelivery = $('#homeDelivery');
  const $termsError = $('.t-and-c-error');
  const $colissimoPickup = $('#colissimoPickUp');
  const $inputDelivery = $('input[name="delivery"]');
  const $homeDeliveryInput = $('#homeDeliveryRadio');

  const cocElement = document.querySelector('.js-delivery');
  const ishomeDelivery = document.getElementById('homeDelivery');
  const userCocCountryName = cocElement?.dataset.deliveryCountry;
  const checkoutSubmit = document.querySelector('input.btn-checkout[name="checkout"]');

  const current_country = userCocCountryName;
  let country_postal_code, current_city;
  if(current_country == 'DE') {
    country_postal_code = '10115';
    current_city = 'Berlin'
  }
  else if(current_country == 'ES') {
    country_postal_code = '28038';
    current_city = 'Madrid'
  }
  else if(current_country == 'BE') {
    country_postal_code = '1000';
    current_city = 'Bruxelles'
  }
  else if(current_country == 'NL') {
    country_postal_code = '1011 AB';
    current_city = 'Amsterdam'
  }
  else if(current_country == 'LU') {
    country_postal_code = '1111';
    current_city = 'Luxembourg'
  }
  else if(current_country == 'AT') {
    country_postal_code = '1010';
    current_city = 'Wien'
  }
  else if(current_country == 'IT') {
    country_postal_code = '00100';
    current_city = 'Roma'
  }
  else if(current_country == 'PT') {
    country_postal_code = '1300-123';
    current_city = 'Lisboa'
  }

  function handleCCOption() {
    setTimeout(function () {
      $buttonAdd.show();
      $('.relay_note').show();
    }, 1500);
    $("#zonewidget .container").trigger("MR_RebindMap");
      $(document).ready(function() {
        $storeInfo.val();
        var islgscreen = false;

        if ($(window).width() > 798) {
          islgscreen = true;
        }

        $.magnificPopup.open({
          items: {
            src: '#container-zonewidget'
          },
          type: 'inline',
          mainClass: 'modal_zonewidget mfp-fade',
          removalDelay: 300
        });

        $buttonAdd.unbind("click").on('click', function() {
          $.magnificPopup.close();
        });

        $zoneWidget.MR_ParcelShopPicker({
          Target: "#Retour_Widget",
          Brand: "F1L4COOK",
          NbResults: "10",
          Country: current_country,
          City: current_city,
          AllowedCountries: "DE,AT,IT,ES,PT,BE,NL,LU",
          PostCode: country_postal_code,
          EnableGeolocalisatedSearch: "true",
          ColLivMod: "24R",
          Responsive: true,
          OnParcelShopSelected: function (data) {
            $storeInfo.val(JSON.stringify(data));
            const storePickupAddress = $pickupAddress;
            storePickupAddress.empty();
            var store_addr = (data.Adresse2) ? data.Adresse1 +  ''  + data.Adresse2 : data.Adresse1
            storePickupAddress.prepend(`<div class="nom">${data.Nom}</div><div class="addr">${store_addr}</div><div class="city_zip">${data.CP} - ${data.Ville}</div>`);
            const baleares_postal_code = data.CP.slice(0, 2);
            if(data.Pays == 'ES') {
                let obj = JSON.parse(JSON.stringify(data));
              if(baleares_postal_code == '07') {
                cocElement && (cocElement.dataset.deliveryCountry = 'ES-PM');
                obj['Province'] = 'PM';
                $storeInfo.val(JSON.stringify(obj));
              } else {
                cocElement && (cocElement.dataset.deliveryCountry = 'ES');
                delete obj['Province'];
                $storeInfo.val(JSON.stringify(obj));
              }
              setTimeout(() => {
                determineZoneAndDeliveryOption();
              }, 1000);
            }

            $(document).on('click', '#zonewidget .PR-List-Item', function(){
              $('#zonewidget .remodal-confirm').removeClass('hide');
            });
            $homeDelivery.val("NA");
          }
        });
    });
  }

  function hideErrorForStorePickup(){
    $pickupError.hide();
  }

  function hideErrorForShippingMethod() {
    $shippingNotSelectedError.hide();
  }

  $(document).ready( function() {
      $("#checkout").unbind("click").on('click', function() {
      if ($('#agree').is(':checked')) {
        if($inputDelivery.is(':checked')) {
          if (($pickupInput.is(':checked') && $storeInfo.val() === 'NA' &&
          $colissimoPickup.val() === 'false') || !$storeInfo.val()) {
            $pickupError.show();
            return false;
          } else {
            if ($homeDeliveryInput.is(':checked') && ($homeDelivery.val() === 'NA'|| !$homeDelivery.val())) {
              $homeDelivery.val("homeDelivery");
            }
            $(this).submit();
          }
        } else if($('#containStandardProduct').val() === 'false') {
          $(this).submit();
        } else {
            $shippingNotSelectedError.show();
          return false;
        }
      }
      else {
        $termsError.show();
        return false;
      }
    });
    $('#agree').change(function() {
      if(this.checked) {
        $termsError.hide();
      }
    });
    $storeInfo.val('NA');
    $inputDelivery.prop('checked', false);
    $homeDelivery.val("NA");
    hideErrorForStorePickup();
    hideErrorForShippingMethod();

    $( ".relay_link" ).on( "click", function() {
      handleCCOption();
      hideErrorForStorePickup();
    });

    $inputDelivery.change(function(e) {
      var $current = $(this);
      e.preventDefault()
      e.stopPropagation()
      $('input', $current).prop('checked', true);
      $("#custom-delivery-methods").find('.deliveryDetails').hide();
      $($current.parent().siblings('.deliveryDetails')).show();
      if($current.is("#homeDeliveryRadio")) {
        $storeInfo.val('NA');
        $pickupAddress.empty();
        $homeDelivery.val("homeDelivery");
      }
      hideErrorForStorePickup();
      hideErrorForShippingMethod();
    });
  });

  ishomeDelivery && ishomeDelivery.addEventListener('input', function() {
    localStorage.removeItem('user-country');
  });

  async function disableCheckoutButton() {
    if(checkoutSubmit) checkoutSubmit.disabled = true;

    window.addEventListener('load', () => {
      if(checkoutSubmit) checkoutSubmit.disabled = false;
    });
  }

  disableCheckoutButton();
})();
